module.exports = __webpack_public_path__ + "img/whatsapp.cad6fd3a.png";